<template>
  <q-select
          v-if="isGranted('SELECT_PAYMENT_METHOD')"
          :model-value="modelValue"
          :options="paymentMethods"
          option-value="id"
          :label="modelValue ? 'Payment Method' : 'Select a Payment Method'"
          :loading="isLoading"
          :map-options="!object"
          v-bind="$attrs"
          @update:model-value="select">
    <template v-slot:option="scope">
      <payment-method-item
              :payment-method="scope.opt"
              v-bind="scope.itemProps"
      />
    </template>
    <template v-slot:selected-item="scope">
      <payment-method-item
              v-if="isObject(scope.opt)"
              class="q-px-none"
              :payment-method="scope.opt"
              @click="select(scope.opt)"
      />
    </template>
  </q-select>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import isGranted from '@/auth/isGranted';
import { PaymentMethod } from '@/type';
import { HasTaskMixin } from '@/mixins';
import repository from './paymentMethodRepository';
import PaymentMethodItem from './PaymentMethodItem.vue';

interface Data {
  paymentMethods: PaymentMethod[],
  task: Promise<PaymentMethod[]>|null,
}

export default defineComponent({
  emits: ['update:modelValue'],
  components: { PaymentMethodItem },
  mixins: [HasTaskMixin],
  props: {
    customerId: {
      type: Number,
      required: true,
    },
    modelValue: [Number, Object as () => PaymentMethod],
    object: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      paymentMethods: [],
      task: null,
    };
  },
  methods: {
    load() {
      this.task = repository.findAll(this.customerId);
      this.task.then((paymentMethods: PaymentMethod[]) => {
        this.paymentMethods = paymentMethods;
        this.initialize();
      });
    },
    select(paymentMethod: PaymentMethod|null) {
      let value:PaymentMethod|number|null = paymentMethod;
      if (paymentMethod) {
        value = (this.object) ? paymentMethod : paymentMethod.id;
      }
      this.$emit('update:modelValue', value);
    },
    initialize() {
      if (this.paymentMethods.length === 1 && !this.modelValue) {
        this.select(this.paymentMethods[0]);
      }
    },
    isObject(value: any) {
      return _.isObject(value);
    },
    isGranted,
  },
  created() {
    this.load();
  },
});
</script>
